<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <sequential-entrance from-top>
      <v-row>
        <v-col>
          <base-material-card
            color="primary"
            icon="mdi-bank-transfer-out"
            inline
            title="Tip Management"
          >
            <v-col cols="12">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              />
            </v-col>
            <v-spacer />
            <v-data-table
              :headers="headerforlevel"
              :items="getlocs"
              :search="search"
            >
              <template v-slot:[`item.staff`]="{ item }">
                <v-btn
                  fab
                  color="green"
                  small
                  :to="'/Tippingstaff/' + item.idnum"
                  dark
                >
                  <v-icon dark>
                    mdi-account-cash-outline
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.wallets`]="{ item }">
                <v-btn
                  fab
                  small
                  color="purple"
                  :to="'/Tippingwallets/' + item.idnum"
                  dark
                >
                  <v-icon dark>
                    mdi-wallet
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.reports`]="{ item }">
                <v-btn
                  fab
                  small
                  color="orange"
                  :to="'/Tippingreports/' + item.idnum"
                  dark
                >
                  <v-icon dark>
                    mdi-calendar-today
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </base-material-card>

          <div class="py-3" />
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'Wallets',

    data () {
      return {
        bal: '',
        search: '',
        valid: true,
        headers: [
          { text: 'Site', value: 'name', align: 'left', sortable: true },
          { text: 'Manage Staff', value: 'postdeposits', align: 'center', sortable: false },
          { text: 'Reports', value: 'postshipments', align: 'center', sortable: false },
        ],
        items: [],
        error: '',
        dialog: false,
        icons: true,
        centered: true,
        newtab: null,
        activeBtn: 1,
        grow: true,
        tab: null,

        tabs: 0,
      }
    },
    timers: {
      log: { time: 300000, autostart: true, repeat: true }
    },
    computed: {
      userallowed () {
        if (this.$store.getters.user.status === 'storemanager') {
          return false
        }
        return true
      },
      headerforlevel () {
        this.$log.debug('user level is ', this.$store.getters.user.status)
        if (this.$store.getters.user.status === 'vieweronly') {
          // nothing they can do
        } else if (this.$store.getters.user.status === 'storemanager') {
          return [{
                    sortable: true,
                    text: 'Sites ID',
                    value: 'idnum',
                    width: 150
                  },
                  {
                    sortable: true,
                    text: 'Group',
                    value: 'group',
                    width: 150
                  },
                  {
                    sortable: false,
                    text: 'Manage Staff',
                    value: 'staff',
                    align: 'center'
                  },
                  {
                    align: 'center',
                    sortable: false,
                    value: 'reports',
                    text: 'Daily Volume'
                  },
          ]
        } else if (this.$store.getters.user.status === 'groupmanager') {
          return [
            {
              sortable: true,
              text: 'Sites ID',
              value: 'idnum',
              width: 150
            },
            {
              sortable: true,
              text: 'Group',
              value: 'group',
              width: 150
            },
            {
              sortable: false,
              text: 'Manage Staff',
              value: 'staff',
              align: 'center'
            },
            {
              align: 'center',
              sortable: false,
              value: 'reports',
              text: 'Daily Volume'
            },
          ]
        } else if (this.$store.getters.user.status === 'corporate') {
          this.$log.debug('user is a corp user')
          return [{
                    sortable: true,
                    text: 'Sites ID',
                    value: 'idnum',
                    width: 150
                  },
                  {
                    sortable: true,
                    text: 'Group',
                    value: 'group',
                    width: 150
                  },
                  {
                    sortable: false,
                    text: 'Manage Staff',
                    value: 'staff',
                    align: 'center'
                  },
                  {
                    align: 'center',
                    sortable: false,
                    value: 'reports',
                    text: 'Daily Volume'
                  },
          ]
        } else if (this.$store.getters.user.status === 'admin') {
          this.$log.debug('********   user is admin')
          return [
            {
              sortable: true,
              text: 'Sites ID',
              value: 'idnum',
              width: 150
            },
            {
              sortable: true,
              text: 'Group',
              value: 'group',
              width: 150
            },
            {
              sortable: false,
              text: 'Manage Staff',
              value: 'staff',
              align: 'center'
            },
            {
              align: 'center',
              sortable: false,
              value: 'reports',
              text: 'Daily Volume'
            },
          ]
        }
      },
      getlocs () {
        this.locations = []
        let today = moment().format('YYYY-MM-DD')

        let eventlist = this.$store.getters.notereaderevents

        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          this.$log.debug('key value is ', key)
          let name = 'Unknown'
          let group = 'Unknown'
          let allowedusers = []
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return true
            }
          })
          this.$log.debug('LOC IS ', loc)
          if (loc) {
            group = loc.group
            name = loc.sitename
            allowedusers = loc.allowedusers
          }
          if (value.siteunitsprofile) {
            let rejcount = 0
            let safeid = Object.values(value.siteunitsprofile)[0].crypto_idnum
            this.$log.debug('looking for events for safe ', safeid)
            let events = eventlist.filter(event => event.crypto_idnum === safeid)
            if (events.length > 0) {
              let todaysevents = events.filter(event => event.day === today)
              if (todaysevents.length > 0) {
                this.$log.debug('today is ', today, ' Todays events ', todaysevents)
                rejcount = todaysevents[0].rejcount
                // this.$log.debug('count is ', todaysevents[0].rejcount)
              }
              //
            }
            this.$log.debug('rej count is ', rejcount)

            let rec = this.$store.getters.getheartbeatvalues.find(element => element.crypto_idnum === safeid)
            let status = 'N/A'
            if (rec) {
              let now = Date.now()
              let delta = (now - rec.heartbeat)
              // this.lastheartbeat = moment(rec.heartbeat)
              // this.$log.debug('last heartbeat ', this.lastheartbeat)
              if (delta <= 3600000) {
                status = 'Online'
              }
              if (delta >= 3600000) { // 60  minutes
                status = 'Offline'
              }
            }
            let shop = {
              idnum: key,
              group: group,
              safeid: safeid,
              status: status,
              rejcount: rejcount,
              sitename: name
            }
            let stat = this.$store.getters.user.status
            let usrmail = this.$store.getters.user.email
            if (stat === 'admin' || stat === 'corporate') {
              this.locations.push(shop)
            } else if (stat === 'storemanager' || stat === 'groupmanager' || stat === 'deposituser' || stat === 'vieweronly' || stat === 'deposituser') {
              if (allowedusers) {
                if (allowedusers.includes(usrmail)) {
                  this.locations.push(shop)
                }
              }
            }
          }
          // this.$log.debug(key,value.siteunitsprofile)
        }
        this.$log.debug('our location map ', this.locations)
        return this.locations
      },
      currentsafes () {
        this.$log.debug('SAFES ARE ', this.$store.getters.safesstatus)
        return this.$store.getters.safesstatus
      },
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      },
      groupforuser () {
        let groups = []
        if (this.$store.getters.user.status === 'admin') {
          return this.$store.getters.usergroups
        }
        this.$store.getters.usergroups.forEach(entry => {
          if (entry.name === this.$store.getters.user.group) {
            groups.push(entry)
          }
        })
        return groups
      }
    },
    created () {
      // this.$store.dispatch('resetsafetransactions')
      // this.items = this.$store.getters.safesstatus
    },
    methods: {
      log () {
        // this.$store.dispatch('loadsafes')
      },
      format_time (ts) {
        this.$log.debug('TS ', ts)
        return moment(ts).format('MMMM Do, h:mm:ss')
      },
      request_check_transfer (machine) {
        console.log(machine)
        this.$router.push({ path: '/PaymentsCheck/' + machine.name })
      },
      request_ach_transfer (machine) {
        console.log(machine)

        this.$router.push({ path: '/PaymentsAch/' + machine.name })
      },
      request_payment_history (machine) {
        console.log(machine)

        this.$router.push({ path: '/PaymentsHistory/' + machine.name })
      },
      request_mailbox_deposit (machine) {
        this.$log.debug('REQUEST POST CALLED ', machine)
        this.$log.debug(machine)
        // :to="'/alerts/' + item.id"
        this.$log.debug('ID passed ', machine.id)
        // this.$store.dispatch("loadAlerts", machine.id)
        this.$log.debug('machine id passed ', machine.safeid)
        this.$router.push({ path: '/Depositpost/' + machine.safeid })
      },
      request_mailbox_shipments (machine) {
        this.$log.debug('REQUEST SHIPMENTS CALLED ', machine)
        this.$log.debug(machine)
        // :to="'/alerts/' + item.id"
        this.$log.debug('ID passed ', machine.id)
        // this.$store.dispatch("loadAlerts", machine.id)
        this.$router.push({ path: '/Depositshipments/' + machine.safeid })
      },
      request_mailbox_tracking (machine) {
        this.$log.debug('REQUEST SHIPMENTS CALLED ', machine)
        this.$log.debug(machine)
        // :to="'/alerts/' + item.id"
        this.$log.debug('ID passed ', machine.id)
        // this.$store.dispatch("loadAlerts", machine.id)
        this.$router.push({ path: '/DepositTracking/' + machine.safeid })
      },
      request_labels (machine) {
        this.$log.debug('REQUEST LABELS CALLED ', machine)
        this.$log.debug(machine)
        // :to="'/alerts/' + item.id"
        this.$log.debug('ID passed ', machine.id)
        // this.$store.dispatch("loadAlerts", machine.id)
        this.$router.push({ path: '/Depositlabels/' + machine.safeid })
      },
      request_transactions (machineid) {
        this.$log.debug('machine id passed ', machineid)
      },
      reset () {
        this.wallet = ''
        this.dialog = false
      },
      onDecode (result) {
        // strip out crypto:address
        this.wallet.address = result
      },
      logErrors (promise) {
        promise.catch(console.error)
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
